import { render, staticRenderFns } from "./CadastrarFormaPagamento.vue?vue&type=template&id=5f75caf7&scoped=true"
import script from "./CadastrarFormaPagamento.vue?vue&type=script&lang=js"
export * from "./CadastrarFormaPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f75caf7",
  null
  
)

export default component.exports